<template>
   <div class="provinces">
      <va-page-header>

         <div v-if="provinces !== null" slot="title">
            <span>Kuchi Votes
               <span v-if="this.districts!=null"> - {{province_name}}</span>
               <span v-if="this.centers!=null"> - {{district_name}}</span>
            </span>
            <va-button v-if="this.districts!=null || this.centers!=null" @click.native="goBack" style="position: absolute; right: 22px; top: 70px;"
               type="primary" size="lg">BACK</va-button>
         </div>

         <div v-if="provinces !== null" slot="actions">
            <!-- <va-button style="position: absolute; right: 22px; top: 70px;" type="primary" @click.native="navigate('/survey')">New Survey</va-button> -->
            <!-- <va-button @click.native="navigate('/survey')" style="position: absolute; right: 22px; top: 70px;" type="primary" size="lg">NEW SURVEY</va-button> -->
         </div>

      </va-page-header>
      <va-table v-if="provinces !== null" :hover="true" :full-width="true" class="datatable">
         <table>
            <thead>
               <tr>
                  <th>Name</th>
                  <th>Kuchi Voters</th>
                  <th>Total Centers</th>
                  <!-- <th>Male Stations</th>
            <th>Female Stations</th> -->
                  <th>Kuchi Stations</th>
                  <!-- <th>Hindu Stations</th>
            <th>Voters(m)</th>
            <th>Voters(f)</th> -->
                  <!-- <th>Hindu Voters</th> -->
               </tr>
            </thead>
            <tbody>
               <tr v-if="districts==null && centers==null" v-for="province in provinces" style="height:38px">
                  <td>
                     <a style="cursor:pointer" @click="loadDistricts(province.id,province.name)">{{province.name}}</a>
                  </td>
                  <td style="font-weight:bold;">{{province.kuchi_votes | numerize}}</td>
                  <td>{{province.pcs}}</td>
                  <td>{{province.kuchi_ps}}</td>

               </tr>

               <tr v-if="districts!=null && centers==null" v-for="district in districts" style="height:38px">
                  <td>
                     <a style="cursor:pointer" @click="loadCenters(district.district_id,district.name)">{{district.name}}</a>
                  </td>
                  <td style="font-weight:bold;">{{district.kuchi_votes | numerize}}</td>
                  <td>{{district.pcs}}</td>
                  <td>{{district.kuchi_ps}}</td>

               </tr>

               <tr v-if="districts!=null && centers!=null" v-for="center in centers" style="height:38px">
                  <td>
                     {{center.pc_location}}
                  </td>
                  <td style="font-weight:bold;">{{center.kuchi_votes | numerize}}</td>
                  <td>{{center.pc_name}}</td>
                  <td>{{center.kuchi_ps}}</td>

               </tr>
            </tbody>
         </table>
      </va-table>

      <loader v-else-if="loading" />

      <div v-else :class="$style.deadCenter">
         <p>No provinces available</p>
         <br>
         <va-button type="primary" @click.native="navigate('/survey')">New Survey</va-button>
      </div>
   </div>
</template>

<script>
   // @ is an alias to /src
   import {
      mapGetters,
      mapActions
   } from "vuex";
   import loader from "@/components/Loader";
   export default {
      name: "home",
      data() {
         return {
            loading: true,
            provinces: null,
            province_name: null,
            province_id: null,
            district_id: null,
            district_name: null,
            districts: null,
            centers: null,
         };
      },
      components: {
         loader
      },
      filters: {
         numerize(v) {
            let n = v || 0;
            return parseInt(n).toLocaleString();
         }
      },
      computed: {
         // ...mapGetters(["getSurveys"])
      },
      methods: {
         // ...mapActions(["fetchSurveys"]),
         navigate(to) {
            this.$router.push(to);
         },
         goBack() {
            if (this.province_id != null && this.district_id == null) {
               this.province_id = null;
               this.districts = null;
            }
            if (this.province_id != null && this.district_id != null) {
               this.district_id = null;
               this.centers = null;
            }
         },
         loadDistricts(p, p_name) {
            var districts = [];
            var districtsRef = db.collection("districts");
            if (districtsRef !== null) {
               districtsRef.where("province_id", "==", p * 1).get().then(snap => {
                  districts = [];
                  snap.forEach(doc => {
                     if (doc.data().kuchi_votes > 0)
                        districts.push({
                           id: doc.id,
                           ...doc.data()
                        });
                  });
                  this.districts = districts.sort((a, b) => a.id - b.id);
                  this.province_id = p;
                  this.province_name = p_name;
                  this.loading = false;
               });
            }
         },
         loadCenters(d, d_name) {
            var centers = [];
            var centersRef = db.collection("pcs");
            // console.log("fethcing centers: ", this.province_id, d);
            if (centersRef !== null) {
               centersRef
                  .where("province_id", "==", this.province_id.toString().padStart(2, "0"))
                  .where("district", "==", d_name)
                  .get().then(snap => {
                     centers = [];
                     snap.forEach(doc => {
                        // console.log(doc.data());
                        if (doc.data().kuchi_voters > 0)
                           centers.push({
                              id: doc.id,
                              ...doc.data(),
                              kuchi_votes: doc.data().kuchi_voters
                           });
                     });
                     this.centers = centers.sort((a, b) => a.id - b.id);
                     this.district_id = d;
                     this.district_name = d_name;
                     this.loading = false;
                  });
            }
         },
      },
      mounted() {
         var provinces = [];
         var provincesRef = db.collection("provinces");
         if (provincesRef !== null) {
            provincesRef.get().then(snap => {
               provinces = [];
               snap.forEach(doc => {
                  if (doc.data().kuchi_votes > 100)
                     provinces.push({
                        id: doc.id,
                        ...doc.data()
                     });
               });
               this.provinces = provinces.sort((a, b) => a.id - b.id);
               this.loading = false;
            });
         }
      }
   };
</script>

<style module>
   .va-page-header-breadcrumb-wrapper {
      display: none;
   }

   .deadCenter {
      bottom: 0;
      height: 100px;
      left: 0;
      margin: auto;
      position: absolute;
      top: 0;
      right: 0;
      text-align: center;
   }

   .horCenter {
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
   }

   .loader {
      margin: auto;
      text-align: center;
   }

   .homeContent {
      text-align: center;
   }
</style>